import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ExpandableContainerWidget: WidgetRegistryEntry = {
  name: "ExpandableContainer",
  component: () => import("./expandable-container-widget.component").then((m) => m.ExpandableContainerWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ExpandableContainerWidgetConfiguration)
};
